import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import v from 'scss/v';
import { I18N, I18NContext } from 'commons';
import ViewOnMap from 'components/modals/view-on-map';
import * as locationSelectors from 'state/selectors/locationSelectors';
import * as locationActions from 'state/actions/locationActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const SummaryList = ({
  addresses,
  resetLocationValues,
  editLocation,
  setIsAddressVerifyPass,
  setFieldValue,
  isHasPrivateLocation,
  setIsEditLocation,
  isAddressVerifyPass
}) => {
  const i18n = useContext(I18NContext);
  const [isOpenViewOnMap, setIsOpenViewOnMap] = useState(false);

  const openViewOnMap = () => setIsOpenViewOnMap(true);
  const closeViewOnMap = () => setIsOpenViewOnMap(false);

  const [{ position: { lat, lng } }] = addresses;
  const viewOnMapDisabled = !(lat && lng);

  const Container = styled.div`
    border:1px solid ${v('$grayscale-silverlight')};
    padding-top: 1rem;
    h4 {
      line-height: 2rem;
    }
    p {
      line-height: 1.75rem;
    }
    h4,
    p {
      margin: 0;
      padding: 0 1.25rem;
    }
    p:last-child {
      line-height: 52px;
      display: flex;
      justify-content: flex-end;
      button {
        padding: 0.75rem 0.25rem;
      }
    }
    `;

  const edit = () => {
    setIsAddressVerifyPass(false);
    setIsEditLocation(true);
  };

  useEffect(() => {
    document.getElementById('edit_button').focus();
  }, []);

  const verifyResult = useRef()
  useEffect(() => {
    if (isAddressVerifyPass && !isOpenViewOnMap) {
      setTimeout(() => {
        verifyResult && verifyResult.current && verifyResult.current.focus()
      });
    }
  }, [isAddressVerifyPass, isOpenViewOnMap])

  return (
    <div className="form-group row" >
      {addresses.map((address, index) => (
        <div className="col-md-12" key={`location-information-address-${String(index)}`}>
          <Container>
            <h4
              tabIndex={-1} ref={verifyResult}
              aria-describedby="street cityStatePostalCode countryName"
            >{address.locationName}
            </h4>
            <p id="street">
              {address.street} {address.suite}
            </p>
            <p id="cityStatePostalCode">
              {address.city && `${address.city}, `}
              {address.state && `${address.state} `}
              {address.postalCode}
            </p>
            <p id="countryName">{address.countryName}</p>
            <div className="text-right p-3">
              <Button
                id="edit_button"
                color="link"
                onClick={edit}
                eb-test="ssp_signup_link_edit_address"
              >
                <I18N>ssp.address.grid.edit</I18N>
              </Button>
              {!viewOnMapDisabled &&
                <Button
                  color="link"
                  onClick={openViewOnMap}
                  eb-test="ssp_signup_link_view_on_map"
                >
                  <I18N>ssp.address.viewonmap</I18N>
                </Button>
              }
              {!isHasPrivateLocation &&
                <Button
                  color="link"
                  className="ml-2 p-0"
                  aria-label={i18n['location.button.delete.alt.text']}
                  onClick={() => {
                    setIsAddressVerifyPass(false);
                    setIsEditLocation(false);
                    resetLocationValues('delete');
                  }}
                >
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    alt={i18n['location.button.delete.alt.text']}
                    width="0.875em"
                    height="1em"
                  />
                </Button>
              }
            </div>
          </Container>
        </div>
      ))}
      <ViewOnMap
        isOpen={isOpenViewOnMap}
        close={closeViewOnMap}
        ok={closeViewOnMap}
        address={addresses[0]}
      />
    </div>
  );
};

SummaryList.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  editLocation: PropTypes.func.isRequired,
  resetLocationValues: PropTypes.func.isRequired,
  isHasPrivateLocation: PropTypes.bool.isRequired,
  setIsAddressVerifyPass: PropTypes.func.isRequired,
  setIsEditLocation: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  addresses: locationSelectors.selectLocationAddresses(state),
});

const mapDispatchToProps = dispatch => ({
  editLocation: payload => dispatch(locationActions.editLocation(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SummaryList);
